module.exports = __webpack_public_path__ + "assets/img/7e71-lt.svg";